<template>
  <div v-if="league" class="row">
    <div class="col-12">
      <article v-if="myTrades" class="fc-m-container ">
        <h2 class="fc-m-container__header">
          <span class="mb-4 mb-md-0">My Trades</span>
          <div class="">
            <span>
              <router-link :to="{ name: 'New Trade' }" class=" btn btn-primary"
                >Propose Trade</router-link
              >
            </span>
          </div>
        </h2>
        <p>Trades expire 7 days after they are proposed.</p>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Legislators</th>
              <th scope="col" class="d-none d-lg-table-cell">Teams</th>
              <th scope="col" class="d-none d-sm-table-cell">Expires</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="trade in myTrades" :key="trade.id">
              <td>
                <router-link
                  class="fc-a-link--casual"
                  :to="{
                    name: ':member',
                    params: { memberId: trade.member_initiated.id }
                  }"
                >
                  {{
                    `${
                      trade.member_initiated.common_name != ""
                        ? trade.member_initiated.common_name
                        : trade.member_initiated.first_name
                    } ${trade.member_initiated.last_name}`
                  }}</router-link
                >
                for
                <router-link
                  class="fc-a-link--casual"
                  :to="{
                    name: ':member',
                    params: { memberId: trade.member_proposed.id }
                  }"
                >
                  {{
                    `${
                      trade.member_proposed.common_name != ""
                        ? trade.member_proposed.common_name
                        : trade.member_proposed.first_name
                    } ${trade.member_proposed.last_name}`
                  }}</router-link
                >
              </td>
              <td class="d-none d-lg-table-cell">
                <div class="">
                  From:
                  <router-link
                    class="fc-a-link--casual"
                    :to="
                      `/leagues/${league.id}/teams/${trade.team_initiated.id}/`
                    "
                  >
                    {{ trade.team_initiated.name }}</router-link
                  >
                </div>
                <div class="">
                  To:
                  <router-link
                    class="fc-a-link--casual"
                    :to="
                      `/leagues/${league.id}/teams/${trade.team_proposed.id}/`
                    "
                  >
                    {{ trade.team_proposed.name }}</router-link
                  >
                </div>
              </td>
              <td class="d-none d-sm-table-cell">{{ trade.expires }}</td>
              <td>
                <router-link
                  v-if="trade.created_by.id != $store.state.auth.user_id"
                  class="btn btn-primary"
                  :to="`/leagues/${league.id}/trades/${trade.id}/`"
                  >Respond</router-link
                >
                <button
                  v-else
                  @click="deleteTrade(trade.id)"
                  class="btn btn-danger"
                >
                  Delete
                </button>
              </td>
            </tr>
            <tr v-if="!myTrades.length">
              <td colspan="4">No pending trades.</td>
            </tr>
          </tbody>
        </table>
        <pagination
          v-if="myTradesPrevious || myTradesNext"
          v-bind:next="myTradesNext"
          v-bind:previous="myTradesPrevious"
          @newPage="getMyTrades"
        ></pagination>
      </article>
      <loader v-else v-bind:embeded="false"></loader>
    </div>
    <div class="col-12">
      <article v-if="allTrades" class="fc-m-container ">
        <h2>All Trades</h2>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">Legislators</th>
              <th scope="col" class="d-none d-sm-table-cell">Teams</th>
              <th scope="col">Status</th>
              <th scope="col" class="d-none d-lg-table-cell">Requested By</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="trade in allTrades"
              :key="trade.id"
              :class="{ faded: trade.status != 'Pending' }"
            >
              <td>
                <router-link
                  class="fc-a-link--casual"
                  :to="{
                    name: ':member',
                    params: { memberId: trade.member_initiated.id }
                  }"
                >
                  {{
                    `${
                      trade.member_initiated.common_name != ""
                        ? trade.member_initiated.common_name
                        : trade.member_initiated.first_name
                    } ${trade.member_initiated.last_name}`
                  }}</router-link
                >
                for
                <router-link
                  class="fc-a-link--casual"
                  :to="{
                    name: ':member',
                    params: { memberId: trade.member_proposed.id }
                  }"
                >
                  {{
                    `${
                      trade.member_proposed.common_name != ""
                        ? trade.member_proposed.common_name
                        : trade.member_proposed.first_name
                    } ${trade.member_proposed.last_name}`
                  }}</router-link
                >
              </td>
              <td class="d-none d-sm-table-cell">
                <div class="">
                  From:
                  <router-link
                    class="fc-a-link--casual"
                    :to="
                      `/leagues/${league.id}/teams/${trade.team_initiated.id}/`
                    "
                  >
                    {{ trade.team_initiated.name }}</router-link
                  >
                </div>
                <div class="">
                  To:
                  <router-link
                    class="fc-a-link--casual"
                    :to="
                      `/leagues/${league.id}/teams/${trade.team_proposed.id}/`
                    "
                  >
                    {{ trade.team_proposed.name }}</router-link
                  >
                </div>
              </td>
              <td>{{ trade.status }}</td>
              <td class="d-none d-lg-table-cell">
                <span v-if="trade.created_by.id == $store.state.auth.user_id">
                  You
                </span>
                <span v-else>
                  {{ trade.created_by.username }}
                </span>
              </td>
            </tr>
            <tr v-if="!allTrades.length">
              <td colspan="4">No trades in this league so far.</td>
            </tr>
          </tbody>
        </table>
        <pagination
          v-if="allTradesPrevious || allTradesNext"
          v-bind:next="allTradesNext"
          v-bind:previous="allTradesPrevious"
          @newPage="getAllTrades"
        ></pagination>
      </article>
      <loader v-else v-bind:embeded="false"></loader>
    </div>
  </div>
  <loader v-else v-bind:embeded="false"></loader>
</template>

<script>
import { getCookie } from "@/utils/cookies.js";
import Loader from "@/views/components/Loader";
import moment from "moment-timezone";
import Pagination from "@/views/components/Pagination";
import { handleResponse, catchError } from "@/utils/errors.js";

export default {
  name: "TradesList",
  components: {
    loader: Loader,
    pagination: Pagination
  },
  data: function() {
    return {
      league: null,
      myTrades: null,
      myTradesPrevious: null,
      myTradesNext: null,
      allTrades: null,
      allTradesPrevious: null,
      allTradesNext: null
    };
  },
  created: function() {
    this.getLeague();
  },
  methods: {
    getLeague: function() {
      let app = this;
      //get league data, save accordingly
      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }`,
        {
          credentials: "include",
          mode: "cors"
        }
      )
        .then(function(response) {
          return response.json();
        })
        .then(function(response) {
          app.$store.commit("breadcrumb/updateDynamicLinks", {
            dynamic_links: [
              {
                static_name: ":league",
                dynamic_name: response.name,
                url: `/leagues/${response.id}`
              }
            ]
          });
          app.$store.commit("breadcrumb/display");
          app.league = response;
          let team = response.teams.find(team =>
            team.owners.find(owner => owner.id == app.$store.state.auth.user_id)
          );
          if (team) {
            let myTradesUrl = `${process.env.VUE_APP_PLATFORM}/api/leagues/${
              app.$route.params.leagueId
            }/trades/?team=${
              team.id
            }&pending=True&ordering=created&limit=10&offset=0`;
            app.getMyTrades(myTradesUrl);
          } else {
            app.myTrades = [];
          }
          let allTradesUrl = `${process.env.VUE_APP_PLATFORM}/api/leagues/${
            app.$route.params.leagueId
          }/trades/?ordering=-created&limit=15&offset=0`;
          app.getAllTrades(allTradesUrl);
        });
    },
    getMyTrades: function(url) {
      let app = this;
      app.myTrades = null;
      // get trades for my team
      fetch(url, {
        credentials: "include",
        mode: "cors"
      })
        .then(handleResponse)
        .then(function(response) {
          let trades = response.results;
          // get ids of all members involved in these trades
          let ids = trades
            .map(t => [t.member_initiated, t.member_proposed])
            .flat()
            .filter((i, index, arr) => arr.indexOf(i) === index);

          if (ids.length) {
            // add member info and status to trade obj
            app.getCongressMembers(ids).then(function(congress) {
              let members = congress.results;
              app.myTradesPrevious = response.previous;
              app.myTradesNext = response.next;
              app.myTrades = app.cleanTrades(trades, members);
            });
          } else {
            app.myTrades = [];
          }
        })
        .catch(catchError);
    },
    getAllTrades: function(url) {
      let app = this;
      app.allTrades = null;
      // get trades for my team
      fetch(url, {
        credentials: "include",
        mode: "cors"
      })
        .then(handleResponse)
        .then(function(response) {
          let trades = response.results;
          // get ids of all members involved in these trades
          let ids = trades
            .map(t => [t.member_initiated, t.member_proposed])
            .flat()
            .filter((i, index, arr) => arr.indexOf(i) === index);

          if (ids.length) {
            // add member info and status to trade obj
            app.getCongressMembers(ids).then(function(congress) {
              let members = congress.results;
              app.allTradesPrevious = response.previous;
              app.allTradesNext = response.next;
              app.allTrades = app.cleanTrades(trades, members);
            });
          } else {
            app.allTrades = [];
          }
        })
        .catch(catchError);
    },
    cleanTrades: function(trades, congress) {
      for (let i = 0; i < trades.length; i++) {
        trades[i].member_initiated = congress.find(
          m => m.id == trades[i].member_initiated
        );
        trades[i].member_proposed = congress.find(
          m => m.id == trades[i].member_proposed
        );
        let not_accepted =
          !trades[i].accepted && !trades[i].pending
            ? trades[i].cancel_reason
            : "Pending";
        trades[i].status = trades[i].accepted ? "Accepted" : not_accepted;
        if (trades[i].pending) {
          // trades expire 1wk at midnight EST of when they were created
          trades[i].expires = moment
            .utc(trades[i].created)
            .add(1, "week")
            .tz("America/New_York")
            .startOf("day")
            .format("MM/DD/YY");
        }
      }
      return trades;
    },
    getCongressMembers: function(memberIds) {
      let app = this;
      let members = memberIds.join(",");
      let url = `${
        process.env.VUE_APP_CONGRESS
      }/api/members/?limit=60&id__in=${members}`;

      return fetch(url).then(function(response) {
        return response.json();
      });
    },
    deleteTrade: function(tradeId) {
      let app = this;
      const csrftoken = getCookie("csrftoken");

      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/trades/${tradeId}/`,
        {
          credentials: "include",
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response) {
        if (response.status == 200 || response.status == 204) {
          app.$router.push(`/leagues/${app.league.id}/`);
          app.$store.commit("alert/addMessage", {
            message: `Trade deleted.`,
            class: "success",
            persist: false
          });
        } else {
          app.$store.commit("alert/addMessage", {
            message: `Unable to delete trade.`,
            class: "danger",
            persist: false
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.faded {
  opacity: 0.7;
}
</style>
